import { ClinicAndFlags } from '@/modules/Auth/auth-types'
import { extract } from '@/modules/MedicalSpecialities/classes/Speciality'
import { AVAILABLE_SPECIALITIES } from '@/modules/MedicalSpecialities/constants'

export const buildServicesForCRMEvent = (userClinic: ClinicAndFlags) => {
  const specialities = extract(AVAILABLE_SPECIALITIES, userClinic?.clinic)
  const mappedServices = AVAILABLE_SPECIALITIES.map(spec => {
    if (specialities[spec]?.habilitado) {
      return specialities[spec]?.id
    }
    return null
  })
  return mappedServices?.filter(service => service !== null)
}
